module.exports = __webpack_public_path__ + "static/media/closed.fbd9faa0.svg";